/** Stage 1 tokens only — every value here is verified by check-contrast.mjs. */

export const phaseCardSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
  p: 1.5,
  borderRadius: 'var(--app-radius-sm)',
  bgcolor: 'var(--app-response-card-bg)',
  border: 'none',
  boxShadow: 'var(--app-response-card-shadow)',
  color: 'var(--app-response-card-body)',
  font: 'inherit',
}

export const phaseBadgeSx = {
  flexShrink: 0,
  px: 0.75,
  py: '2px',
  borderRadius: '999px',
  fontSize: 11,
  fontWeight: 700,
  lineHeight: 1.4,
  color: 'var(--app-phase-fg)',
  bgcolor: 'var(--app-phase-bg)',
  border: '1px solid var(--app-phase-border)',
}

export const phaseTimeframeSx = {
  alignItems: 'center',
  gap: 0.375,
  ml: 'auto',
  px: 0.75,
  py: '2px',
  borderRadius: '999px',
  fontSize: 11,
  fontWeight: 600,
  whiteSpace: 'nowrap',
  color: 'var(--app-status-unclear-fg)',
  bgcolor: 'var(--app-status-unclear-bg)',
  border: '1px solid var(--app-status-unclear-border)',
}

/** Single column below this width — the cards are prose, never a grid. */
export const phaseListSx = { display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }
